
export type CreateChatThreadResponseAllOfCurrentUserStatusStatus = typeof CreateChatThreadResponseAllOfCurrentUserStatusStatus[keyof typeof CreateChatThreadResponseAllOfCurrentUserStatusStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateChatThreadResponseAllOfCurrentUserStatusStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  BLOCKED: 'BLOCKED',
} as const;
